import React, { useState, useCallback, useEffect } from 'react';
import Layout from '../../layout/default';
import './styles.scss';
import dayjs from 'dayjs';
import { DATE_FORMAT } from '../../constants';
import { getAllUsers } from '../../services/user';
import { STATIC_ROUTES } from '../../constants/routes';
import { useNavigate } from 'react-router-dom';

const GeneralUsers = () => {
  const [search, setSearch] = useState('');
  const [users, setUsers] = useState([]);
  const navigate = useNavigate();

  const getUsers = useCallback(async () => {
    try {
      const response = await getAllUsers({
        search: search,
      });
      if (response) {
        setUsers(response.data);
      }
    } catch (e) {
      console.log(e);
    }
  }, [search]);

  useEffect(() => {
    const count = (search.match(/\d/g) || []).length;

    if (count > 3) {
      getUsers();
    } else {
      setUsers([]);
    }
  }, [search]);

  return (
    <Layout
      title="Users"
      breadcrumbs={[
        {
          name: 'User List',
        },
      ]}
    >
      <div className={`page-wrapper general-users-page`}>
        <div className="library-filter">
          <div className="library-filter-search form-control-item">
            <input type="text" className="form-control" value={search} onChange={(e) => setSearch(e.target.value)} placeholder="Search" />
            <i className="icon-search"></i>
          </div>
          <button className="btn btn-outline clear-btn" onClick={() => setSearch('')}>
            Clear
          </button>
        </div>

        <div className={'table-container'}>
          <table className={'general-users-table'}>
            <thead>
              <tr>
                <th>
                  Last Name <span className="total-title">(Total: {users.length})</span>
                </th>
                <th>Name</th>
                <th>Company</th>
                <th>Facility</th>
                <th>Date Added</th>
              </tr>
            </thead>
            <tbody>
              {users.length === 0 ? (
                <tr>
                  <td colSpan={6} style={{ height: 128, textAlign: 'center', verticalAlign: 'middle' }}>
                    No data available
                  </td>
                </tr>
              ) : (
                users.map((user) => (
                  <tr key={user.id} onClick={() => navigate(STATIC_ROUTES.GENERAL_USERS_DETAIL.replace(':id', user.id))}>
                    <td className="last-name-col">{user.last_name}</td>
                    <td>{user.first_name}</td>
                    <td>{user.company_name}</td>
                    <td>{user.facility_name}</td>
                    <td>{dayjs(user.created_at).format(DATE_FORMAT)}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </Layout>
  );
};

export default GeneralUsers;
